import { TextSizes } from '~/components/atoms/Text/Text'

export enum componentType {
  standard = 'standard',
  question = 'question',
  pageBlock = 'pageBlock',
  prominentTextBlock = 'prominentTextBlock',
}

export const componentTypes = {
  [componentType.standard]: {
    title: TextSizes.primaryTitleLrger,
    textSize: TextSizes.bodyLrg,
  },
  [componentType.question]: {
    title: TextSizes.magSecondaryTitleMedBold,
    textSize: TextSizes.bodyLrg,
  },
  [componentType.pageBlock]: {
    title: TextSizes.primaryTitleLrg,
    textSize: TextSizes.bodyMed,
  },
  [componentType.prominentTextBlock]: {
    title: TextSizes.primaryTitleXLrg,
    textSize: TextSizes.secondaryTitleLrg,
  },
}
